import { gql } from '@apollo/client'

export const CREATE_REQUESTED_INFO_TYPE_MUTATION = gql`
  mutation createRequestedInfoType($attributes: RequestedInfoTypeInput!) {
    createRequestedInfoType(attributes: $attributes) {
      id
      name
      kind
      description
    }
  }
`
